<div class="login-register">
    <div class="login-box">
        <div class="card-body ">

            <div class="text-center">

                <img src="assets/images/logo-givi-blanco.png" class="m-t-30" width="30%">

                <div class="m-t-30">
                    <h1 style="font-size:50px;"><span style="color:#FFFFFF;">¡Descargá<br><span style="color: #FFFF17;">Givi</span> ya!</span></h1>
                </div>

                <div class="m-t-20">
                    <div class="text-white" style="font-size:22px; font-weight: 100;">
                        ... y hagamos que pase.
                    </div>
                </div>

                <div class="d-flex-center ">
                    <div class="m-t-30 m-r-10">
                        <a href="https://apps.apple.com/us/app/givi-regalos-y-experiencias/id6443953772" target="_blank">
                            <img src="assets/images/app-store-apple.png" height="50px" width="100%" />
                        </a>
                    </div>
                    <div class="m-t-30">
                        <a href="https://play.google.com/store/search?q=Givi&c=apps&hl=es_419" target="_blank">
                            <img src="assets/images/app-store-android.png" height="50px" width="100%" />
                        </a>
                    </div>
                </div>
            </div>

            <!-- logo -->
            <div class="m-t-30">
                <img class="img-responsive" src="assets/images/download-givi.jpg">
            </div>
        </div>
    </div>
</div>